import SharePointUpload from '../components/psc/lib/SharePointUpload'
import useBrowserTabTitle from '../hooks/useBrowserTabTitle'
import useProjectContents from '../hooks/useProjectContents';

const RecordSharePointUpload = () => {
    useBrowserTabTitle('Record SharePoint Upload')

    const {
        updateRecord,
    } = useProjectContents()
    
    return (
        <SharePointUpload
            entityType="Record"
            apiPath="records"
            statusField="record_status"
            successCallback={(obj) => updateRecord(obj)}
        />
    )
};

export default RecordSharePointUpload
